/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import * as Sentry from '@sentry/browser'
import React, {Component} from 'react'
import {Error} from '../../features/error'
import {withRouter} from 'react-router-dom'
import {errorMessages} from '../../utils/config'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {hasError: false, errorMessage: null}
    const {history} = this.props

    // Listen for changes to the current location and exit error state when it changes
    history.listen((location, action) => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
          errorMessage: null,
        })
      }
    })
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true}
  }

  getMessage(callStack) {
    let message = ''
    for (let i = 0; i < errorMessages.length; i++) {
      if (callStack.includes(errorMessages[i].name)) {
        message = errorMessages[i].message
        console.error(message)
        return message
      }
    }
    return message
  }

  componentDidCatch(error, errorInfo) {
    // Search the first line of the componentStack and get an appropriate message if we have it in config
    const firstLine = errorInfo.componentStack.split(/\r?\n/)[1]
    const errorMessage = this.getMessage(firstLine)
    this.setState({errorMessage})

    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })

      Sentry.captureException(error)
    })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Error errorInfo={this.state.errorMessage} />
    }

    return this.props.children
  }
}

export default withRouter(ErrorBoundary)
